// Ported from files/snapdraw-design-kit/code/src/lib/i18n/strings/index.ts.
// Flat merged namespace — keys must stay unique across all files below.
import * as account from "./account";
import * as auth from "./auth";
import * as catalog from "./catalog";
import * as clients from "./clients";
import * as common from "./common";
import * as contracts from "./contracts";
import * as dashboard from "./dashboard";
import * as documents from "./documents";
import * as feedback from "./feedback";
import * as help from "./help";
import * as landing from "./landing";
import * as lineitems from "./lineitems";
import * as notifications from "./notifications";
import * as photos from "./photos";
import * as reports from "./reports";
import * as templates from "./templates";

export type Dictionary = Record<string, string>;

const namespaces = [
  account,
  auth,
  catalog,
  clients,
  common,
  contracts,
  dashboard,
  documents,
  feedback,
  help,
  landing,
  lineitems,
  notifications,
  photos,
  reports,
  templates,
];

export const dictionaries: Record<"en" | "es", Dictionary> = {
  en: Object.assign({}, ...namespaces.map((n) => n.en)),
  es: Object.assign({}, ...namespaces.map((n) => n.es)),
};
